
import React, { Component, Fragment, useEffect, useState } from "react";
import {
	Card,
	CardBody,
	CardTitle,
	Row,
	Col,

} from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { authenticationService } from '../../jwt/_services';

import {
	RepairVideosList
} from '../../components/repair-videos/';

class RepairVideos extends React.Component {

	intervalID = 0;

	constructor(props) {
    super(props);

		const currentUser = authenticationService.currentUserValue;

    this.state = {
			currentUser,
	  };

		//this.handleMessage = this.handleMessage.bind(this);
		//this.testCall = this.testCall.bind(this);

  }

	componentDidMount() {

		//this.getData();
	}

	componentWillUnmount() {

	}

	getData = async () => {

		var url = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com/v1/all-devices";

		const response = await fetch(url, {
			method: 'GET',
			headers: {
				Authorization: this.state.currentUser.jwtToken
			},
		});

		const body = await response.json();
		console.log("all devices: " + JSON.stringify(body));

		if (body.status == 'Success') {
			//this.setState({ devices: body.results });
		} else {
      //ADD ERROR MESSAGE
    }

    //this.setState({ devicesLoaded: true });
	};


	render() {
		return (
			<div>
				<Row>
					<Col md="12">
						<RepairVideosList />
					</Col>
				</Row>
			</div>
		);
	}
}

export default RepairVideos;
